import Button from '@material-ui/core/Button'
import { withStyles } from '@material-ui/core/styles'
import cn from 'classnames'

const styles = theme => ({
  root: {
    whiteSpace: 'nowrap',
    height: 36,
    padding: '0 16px',
    color: `var(--gameday-buttons-actionButtonColor, ${theme.buttons.actionButtonColor})`,
    backgroundColor: `var(--gameday-buttons-actionButtonBg, ${theme.buttons.actionButtonBg})`,
    '&.rowActionItem': {
      fontSize: theme.typography.fontSizeSmaller,
      fontWeight: theme.typography.fontWeightSm,
      height: 30,
      minWidth: 30,
      padding: '0 14px',
      '&:not(.white)': {
        'button + &, a + &': {
          marginLeft: 10,
          '.buttonGroup &': {
            marginLeft: 1,
          },
        },
      },
    },
    'tr.disabled &': {
      backgroundColor: `var(--gameday-buttons-actionButtonBgDisabledParent, ${theme.buttons.actionButtonBgDisabledParent})`,
      border: `1px solid var(--gameday-buttons-actionButtonBgDisabledParent, ${theme.buttons.actionButtonBgDisabledParent})`,
    },
    'tr.groupHeader &:not(:hover)': {
      backgroundColor: `var(--gameday-buttons-actionButtonBgDisabledParent, ${theme.buttons.actionButtonBgDisabledParent})`,
    },
    '&.white': {
      backgroundColor: theme.colors.white,
      border: `1px solid ${theme.colors.border}`,
    },
    '&.icon-only': {
      padding: 0,
    },
    '& a': {
      fontWeight: '400',
    },
    '& a:hover': {
      textDecoration: 'none',
    },
    '&:hover': {
      color: `var(--gameday-buttons-actionButtonColor, ${theme.buttons.actionButtonColor})`,
      backgroundColor: `var(--gameday-buttons-actionButtonBgHover, ${theme.buttons.actionButtonBgHover})`,
    },
    '&:disabled': {
      opacity: 1,
      color: `var(--gameday-buttons-actionButtonColorDisabled, ${theme.buttons.actionButtonColorDisabled})`,
      backgroundColor: `var(--gameday-buttons-actionButtonBgDisabled, ${theme.buttons.actionButtonBgDisabled})`,
    },
  },
})

function ClassNames(props) {
  const { children, classes, className, onClick, iconOnly, style, white, ...rest } = props
  return (
    <Button
      color="primary"
      className={cn(classes.root, iconOnly && 'icon-only', white && 'white', className)}
      style={{ ...style }}
      onClick={onClick}
      {...rest}
    >
      {children || 'class names'}
    </Button>
  )
}

ClassNames.defaultProps = {
  white: false,
}

const ActionButton = withStyles(styles)(ClassNames)
ActionButton.displayName = 'ActionButton'
export default ActionButton
